import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface SubscriberValidationResponse extends APIResponse {
    getRespCode(): string;
    getRespDesc(): string;
    getClientTxnId(): string;
    getTxnId(): string;
    getSrvType(): string;
}

export class SubscriberValidationResponseDtoImpl extends APIResponseDtoImpl implements SubscriberValidationResponse {
    private respCode: string;
    private respDesc: string;
    private clientTxnId: string;
    private txnId: string;
    private srvType: string;

    getRespCode(): string {
        return this.respCode;
    }
    setRespCode(respCode: string) {
        this.respCode = respCode;
    }

    getRespDesc(): string {
        return this.respDesc;
    }
    setRespDesc(respDesc: string) {
        this.respDesc = respDesc;
    }

    getClientTxnId(): string {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string) {
        this.clientTxnId = clientTxnId;
    }

    getTxnId(): string {
        return this.txnId;
    }
    setTxnId(txnId: string) {
        this.txnId = txnId;
    }

    getSrvType(): string {
        return this.srvType;
    }
    setSrvType(srvType: string) {
        this.srvType = srvType;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse.tsx